<div class="card_container">
    <img src="{{ landingCard.icon.src }}" alt="{{ landingCard.icon.alt }}">
    <h3>{{ landingCard.title }}</h3>
    <p>{{ landingCard.text }}</p>
</div>
